import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ApiConnectService } from '../../../../services/api-connect.service';
import {
  StandardDiscussionMessageDto,
  StandardDiscussionMessagesDto,
  StandardDiscussionStateDto
} from '../models/standard-discussion.model';

@Injectable()
export class StandardDiscussionApiService {
  constructor(private http: HttpClient,
              private apiUrl: ApiConnectService) {
  }

  startDiscussion(standardId: string): Observable<StandardDiscussionStateDto> {
    return this.http.post<StandardDiscussionStateDto>(this.discussionUrl(standardId) + '/start', {});
  }

  getDiscussion(standardId: string): Observable<StandardDiscussionStateDto> {
    return this.http.get<StandardDiscussionStateDto>(this.discussionUrl(standardId));
  }

  getDiscussionMessages(standardId: string): Observable<StandardDiscussionMessagesDto> {
    return this.http.get<StandardDiscussionMessagesDto>(this.discussionUrl(standardId) + '/messages');
  }

  postDiscussionMessage(standardId: string, text: string): Observable<StandardDiscussionMessageDto> {
    return this.http.post<StandardDiscussionMessageDto>(this.discussionUrl(standardId) + '/messages', { text: text });
  }

  postDocumentUpdatedMessage(standardId: string, fileName: string): Observable<StandardDiscussionMessageDto> {
    return this.http.post<StandardDiscussionMessageDto>(
      this.discussionUrl(standardId) + '/messages',
      { type: 'DOCUMENT_UPDATED', fileName: fileName }
    );
  }

  private discussionUrl(standardId: string): string {
    return this.apiUrl.baseApiUrl + '/common/standard/' + standardId + '/discussion';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/standard-discussion/services/standard-discussion-api.service.ts